// Data source is laws.json (edit that file). These exports keep the app's imports unchanged.
import data from './laws.json';
export const statesData = data.statesData;
export const allStates = Object.values(statesData).flat();
